
const storageRequest={
    add : (request)=>{
        const jsonRequest = JSON.stringify(request)
       // console.log("jsonRequest.set: ",jsonRequest);
        localStorage.setItem('pendingRequest',jsonRequest)
    },
    get: ()=> {
        let jsonRequest = localStorage.getItem('pendingRequest');
        if(jsonRequest===undefined || jsonRequest==="") return undefined
        //console.log("jsonRequest.get: ",jsonRequest);
        let request= JSON.parse(jsonRequest);
        return request;
    },
    remove: ()=>{
        localStorage.setItem('pendingRequest',"")
    }
}




export {
    storageRequest
}

